import http from '../api/api'
import config from '../api/constants'

const deLinkAccountVerify = async (reqParams) => {
  try {
    const params = {
      requestId: 'ACCOUNTDELINKVERIFY',
      ...reqParams
    }
    const response = await http.post(config.apiRoute.DE_LINK_ACCOUNT_VERIFY, params)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const deLinkAccountConfirm = async (reqParams) => {
  try {
    const params = {
      requestId: 'ACCOUNTDELINKCONFIRM',
      ...reqParams
    }
    const response = await http.post(config.apiRoute.DE_LINK_ACCOUNT, params)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const DelinkAccountService = {
  deLinkAccountVerify,
  deLinkAccountConfirm
}

export default DelinkAccountService